module.exports = __webpack_public_path__ + "img/sh_6.93919f41.jpg";